import { FormGroup, FormControl } from '@angular/forms';

export class EmailValidatorComponent {
  static emailCompare(emailFormGroup: FormGroup) {
    if (!emailFormGroup || !emailFormGroup.controls) {
      return null;
    }
    const emailAddressControl = emailFormGroup.controls.emailAddress;
    const email = emailAddressControl?.value;
    const reEmailControl = emailFormGroup.controls.confirmEmailAddress;
    const reEmail = reEmailControl?.value;
    const passed = email?.trim() === reEmail.trim();

    return passed ? null : { emailCompare: true };
  }

  static emailCompareControl(emailFormControl: FormControl) {
    if (!emailFormControl || !emailFormControl.parent) {
      return null;
    }
    const email = emailFormControl?.parent?.controls['emailAddress']['value'];
    const reEmail = emailFormControl.value;
    const passed = email?.trim() === reEmail?.trim();

    return passed ? null : { emailCompare: true };
  }
}
